import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { api, formatErr } from "@/lib/api";
import { toast } from "sonner";
import { LifeBuoy, Loader2 } from "lucide-react";

const VEHICLE_TYPES = ["Otomobil", "Hafif Ticari", "Kamyonet", "Kamyon", "Tır", "Motosiklet", "İş Makinesi", "Diğer"];
const REQUEST_TYPES = ["Çekici gerekiyor", "Araç arızası", "Kaza", "Lastik", "Akü", "Yakıt", "Mekanik arıza", "Diğer"];

export default function HelpRequestModal({ open, onOpenChange, target, userLocation, onCreated }) {
  const [form, setForm] = useState({ customer_vehicle_type: "Otomobil", request_type: "Çekici gerekiyor", customer_vehicle_model: "", description: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!target?.vehicle_id) return;
    if (!userLocation) return toast.error("Konum alınmadı");
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/help-requests", {
        vehicle_id: target.vehicle_id,
        customer_lat: userLocation[0],
        customer_lng: userLocation[1],
        ...form,
      });
      toast.success("Yardım talebiniz gönderildi");
      onCreated?.(data);
      onOpenChange(false);
    } catch (err) {
      toast.error(formatErr(err.response?.data?.detail));
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><LifeBuoy className="w-5 h-5 text-primary" /> Yardım İste</DialogTitle>
        </DialogHeader>
        {target && (
          <div className="rounded-xl bg-primary/10 border border-primary/40 px-3 py-2 text-sm">
            <div className="font-semibold">{target.business?.name}</div>
            <div className="text-xs text-muted-foreground">{target.vehicle_name} · {target.vehicle_type}{target.distance_km != null ? ` · ${target.distance_km < 1 ? Math.round(target.distance_km*1000)+' m' : target.distance_km+' km'}` : ""}</div>
          </div>
        )}
        <form onSubmit={submit} className="space-y-3">
          <div>
            <Label>Araç türünüz</Label>
            <Select value={form.customer_vehicle_type} onValueChange={(v) => setForm({ ...form, customer_vehicle_type: v })}>
              <SelectTrigger data-testid="hr-vtype" className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>{VEHICLE_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Sorun / Talep</Label>
            <Select value={form.request_type} onValueChange={(v) => setForm({ ...form, request_type: v })}>
              <SelectTrigger data-testid="hr-rtype" className="mt-1"><SelectValue /></SelectTrigger>
              <SelectContent>{REQUEST_TYPES.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label>Marka / Model (opsiyonel)</Label>
            <Input data-testid="hr-model" value={form.customer_vehicle_model} onChange={(e) => setForm({ ...form, customer_vehicle_model: e.target.value })} className="mt-1" />
          </div>
          <div>
            <Label>Kısa açıklama (opsiyonel)</Label>
            <Textarea data-testid="hr-desc" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} rows={2} className="mt-1" />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="rounded-full">Vazgeç</Button>
            <Button type="submit" disabled={busy} data-testid="hr-submit" className="rounded-full bg-primary text-[hsl(var(--brand-black))] hover:bg-primary/90 font-bold">
              {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : null} YARDIM TALEBİNİ GÖNDER
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
